module.exports = __webpack_public_path__ + "static/media/list_empty.f53b0691.png";